import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Hero Section - Full-width hero banner with background image
 * Used on the StartPage as the main header/hero
 */
export default function HeroSection({ 
    title, 
    highlightText, 
    description, 
    primaryButtonText, 
    primaryButtonLink, 
    secondaryButtonText, 
    secondaryButtonLink, 
    backgroundImage
}) {
    return (
        <section className="relative overflow-hidden bg-white min-h-screen flex items-center border-b border-gray-200">
            {/* Blurred background image */}
            {backgroundImage && (
                <div 
                    className="absolute bg-cover bg-center"
                    style={{ 
                        backgroundImage: `url(${backgroundImage})`,
                        filter: 'blur(8px)',
                        transform: 'scale(1.1)',
                        top: '-5%',
                        left: '-5%',
                        right: '-5%',
                        bottom: '-5%',
                        zIndex: 0
                    }}
                />
            )}
            
            {/* Dark overlay for better text readability */}
            <div className="absolute inset-0 bg-black/40 z-0" />

            {/* Content */}
            <div className="relative z-10 mx-auto w-full max-w-screen-xl px-6 py-20 sm:px-6 sm:py-24 lg:px-8 lg:py-32">
                <div className="mx-auto max-w-prose text-center">
                    <h1 className="font-heading text-3xl font-bold text-white sm:text-5xl leading-tight break-words">
                        {title}
                    </h1>
                    {highlightText && (
                        <h2 className="font-heading text-2xl font-bold text-sage sm:text-4xl mt-2 break-words">
                            {highlightText}
                        </h2>
                    )}

                    <p className="mt-8 text-base text-pretty text-white sm:text-lg/relaxed leading-relaxed">
                        {description}
                    </p>

                    <div className="mt-8 flex justify-center gap-4 sm:mt-6">
                        {primaryButtonText && primaryButtonLink && (
                            <Link
                                className="inline-block rounded border border-forest bg-forest px-5 py-3 font-medium text-white shadow-sm transition-colors hover:bg-leaf"
                                to={primaryButtonLink}
                            >
                                {primaryButtonText}
                            </Link>
                        )}

                        {secondaryButtonText && secondaryButtonLink && (
                            <Link
                                className="inline-block rounded border border-offwhite bg-offwhite px-5 py-3 font-medium text-charcoal shadow-sm transition-colors hover:bg-leaf border border-leaf"
                                to={secondaryButtonLink}
                            >
                                {secondaryButtonText}
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
